var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { notifyError } from '@/helpers/action';
/**
 * FileUpload エラーハンドリング
 */
export const wrapNotifyFileUploadError = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const { callback, finallyCallback } = args;
    try {
        yield callback();
    }
    catch (error) {
        // Note: 現状処理なし、今後エラー表示等が必要になった場合を想定
        // if (error instanceof FileUploadError) {}
        notifyError();
        // throw error
    }
    finally {
        finallyCallback === null || finallyCallback === void 0 ? void 0 : finallyCallback();
    }
});
